import React from 'react'

export default function NoData({ message }) {
  return (
    <>
      <div className='center-align m-t-20'>
        <i className='fa-light fa-triangle-exclamation' style={{ fontSize: '60px' }} />
        <h3>{ message ?? 'No data yet' }</h3>
      </div>
    </>
  )
}